import anime    from 'animejs/lib/anime.es.js'
import autosize from 'autosize'

class Form
{
    init ()
    {
        const formSections = document.querySelectorAll('section.form')
        
        if (!formSections)
        {
            return false
        }
        
        this.updateTextareas()
        this.initCheckboxes()
        
        for (let section of Array.from(formSections))
        {
            const form = section.querySelector('form')
            
            this.form = form
            this.rgpd = form.querySelector('input#rgpd')
            this.button = form.querySelector('button')
            this.loader = section.querySelector('.loader')
            this.messages = section.querySelector('.messages')
            
            form.addEventListener('submit', (e) =>
            {
                e.preventDefault()
                
                this.send(form)
            })
        }
    }
    
    updateTextareas ()
    {
        const textareas = document.querySelectorAll('textarea')
        
        autosize(textareas)
        
        /*textareas.forEach((el) =>
        {
            const label = el.parentElement.querySelector('label')
            
            el.addEventListener('autosize:resized', () =>
            {
            
            })
        })*/
    }
    
    initCheckboxes ()
    {
        const checkboxes = document.querySelectorAll('input[type="checkbox"]')
        
        for (let checkbox of checkboxes)
        {
            const div = document.createElement('div')
            div.classList.add('checkbox')
            
            checkbox.insertAdjacentElement('afterend', div)
        }
    }
    
    send (form)
    {
        this.button.disabled = true
        //let data = this.serializeForm(this.form)
	
		const data = new FormData(form)
	
		data.append('action', 'process_form')
		data.append('post_id', params.post_id)
		data.append('security', params.form_nonce)

        /*if (data.error)
        {
            this.renderMessage(false, 'Veuillez remplir le champ <span>' + data.field + '</span>')
            this.button.disabled = false
            return false
        }
        
        if (!this.rgpd.checked)
        {
            this.renderMessage(false, 'L\'envoi du formulaire nécessite votre consentement')
            this.button.disabled = false
            return false
        }
        
        data += '&action=process_form&post_id=' + params.post_id + '&security=' + params.form_nonce*/
        
        this.req(form, data, false).then((response) =>
        {
            //this.renderMessage(response.success, response.data.message)
            if (response.success)
            {
                // Nothing
            }
            else
            {
                this.button.disabled = false
            }
        }).catch((error) =>
        {
            //this.renderMessage(false, error)
            this.button.disabled = false
        })
    }
    
    serializeForm (form)
    {
        const fields = [...form.elements]
            .filter(el => el.type !== 'submit')
        
        for (let el of Array.from(fields))
        {
            if (el.value.trim() === '' && el.dataset.required)
            {
                return {
                    error: true,
                    field: el.dataset.label
                }
            }
        }
        
        return [...form.elements]
            .filter(el => el.type !== 'submit' && ((el.type !== 'checkbox' && el.type !== 'radio') || ((el.type === 'checkbox' || el.type === 'radio') && el.checked)))
            .map(el => el.name + '=' + encodeURIComponent(el.value))
            .join('&')
    }
    
    renderMessage (success, message)
    {
        const div = document.createElement('div')
        div.classList.add('message', success ? 'success' : 'error')
        
        const inner = document.createElement('div')
        inner.classList.add('inner')
        inner.innerHTML = message
        
        div.append(inner)
        
        const timeline = anime.timeline({
            targets: div,
            easing: 'easeOutQuart',
            duration: 400
        })
        
        timeline.add({
            opacity: [0, 1],
            translateY: ['100%', 0],
            begin: () =>
            {
                this.messages.appendChild(div)
            }
        }).add({
            opacity: 0,
            translateY: '-100%',
            complete: () =>
            {
                div.remove()
            }
        }, '+=3000')
    }
    
    /*async req (form, data)
    {
        this.loader.classList.add('visible')
        
        return await fetch(params.ajax_url, {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) =>
        {
            this.loader.classList.remove('visible')
            
            return response.ok ? response.json() : Promise.reject(response.statusText)
        })
    }*/
	
	async req (form, data, enableFieldsAfterSuccess = true)
	{
		const fields = Array.from(form.elements)
		
		this.loader.classList.add('visible')
		
		fields.forEach(el =>
		{
			el.disabled = true
		})
		
		return await fetch(params.ajax_url, {
			method: 'POST',
			body: data,
			headers: {
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then((response) =>
		{
			return response.ok ? response.json() : {
				success: false,
				data: {
					message: response.statusText
				}
			}
		}).then((response) =>
		{
			this.loader.classList.remove('visible')
			
			fields.forEach(el =>
			{
				el.disabled = response.success ? !enableFieldsAfterSuccess : false
			})
			
			this.renderMessage(response.success, response.data.message)
			
			return response
		}).catch((error) =>
		{
			this.loader.classList.remove('visible')
			
			fields.forEach(el =>
			{
				el.disabled = false
			})
			
			this.renderMessage(false, error)
		})
	}
}

const form = new Form()

form.init()
